import { translations } from "../../translations"
import styles from "./AboutMeWindow.module.css"

export default function LanguagesSection() {
    return (
        <section className={styles.section}>
            <div className={styles.sectionTitleRow}>
                <img src="/images/icons/globe.svg" className={styles.sectionIconImg} alt="" />
                <h2 className={styles.sectionTitle}>{translations('about_me.languages')}</h2>
            </div>

            <div className={styles.langItem}>
                <div className={styles.langBar} />
                <div>
                    <div className={styles.langTitle}>{translations('about_me.portuguese')}</div>
                    <div className={styles.langSub}>{translations('about_me.native')}</div>
                </div>
            </div>

            <div className={styles.langItem}>
                <div className={styles.langBar} />
                <div>
                    <div className={styles.langTitle}>{translations('about_me.english')}</div>
                    <div className={styles.langSub}>{translations('about_me.advanced')}</div>
                </div>
            </div>
        </section>
    )
}
